// ─── Default workspaces ────────────────────────────────────────────────────
// Every creator gets two seeded categories the first time they save:
//   • "Episodes"   — long-form builds default here unless they pick another
//   • "Short-form" — short-form scripts default here unless they pick another
//
// These are created lazily — on first save of each kind — so we don't write
// rows for users who never use the feature. Subsequent saves reuse the same
// workspace by name (case-insensitive match against existing rows).
//
// Returns the workspace's id. If creation fails (RLS, schema), returns null
// so the caller can still save with workspace_id = null.

import { getWorkspaces, createWorkspace } from './workspaces';

export const DEFAULT_EPISODES_WORKSPACE   = { name: 'Episodes',   icon: '\u{1F3A7}' };
export const DEFAULT_SHORT_FORM_WORKSPACE = { name: 'Short-form', icon: '\u{1F3AC}' };

export async function ensureWorkspaceByName(userId, { name, icon }) {
  if (!userId || !name) return null;
  try {
    const list = await getWorkspaces(userId);
    const match = list.find(w => (w.name || '').trim().toLowerCase() === name.trim().toLowerCase());
    if (match) return match.id;
    const created = await createWorkspace(userId, { name, icon });
    return created?.id || null;
  } catch (err) {
    console.warn('[defaultWorkspaces] ensure failed:', err?.message || err);
    return null;
  }
}

export function ensureEpisodesWorkspace(userId) {
  return ensureWorkspaceByName(userId, DEFAULT_EPISODES_WORKSPACE);
}

export function ensureShortFormWorkspace(userId) {
  return ensureWorkspaceByName(userId, DEFAULT_SHORT_FORM_WORKSPACE);
}
